<template>
    <section class="title-date">
        <h2>{{ titleOption.title }}</h2>
        <section class="date">
            <section class="date-radio" v-if="titleOption.dateRadio" @click="changeDateRadio($event)">
                <span :class="{'active' : dateRadio === 0}" data-type="0">昨天</span>
                <span :class="{'active' : dateRadio === 1}" data-type="1">最近7天</span>
                <span :class="{'active' : dateRadio === 2}" data-type="2">最近30天</span>
            </section>
            <section class="compare-box" v-if="titleOption.dateCompareSelect">
                <v-datepicker :options="dateCompareInputOption" v-model="dateCompareRange.startDate" placeholder="请添加对比日期"></v-datepicker>
                ~
                <span>{{ dateCompareRange.endDate }}</span>
                <input type="button" value="点击对比" @click="compareData" />
            </section>
            <v-datepicker :options="dateInputOption" :message="initDateRange" v-if="titleOption.dateRangeSelect"></v-datepicker>
            <section class="download" v-if="titleOption.download" @click="downloadData">
                下载
            </section>
            <section class="more" v-if="titleOption.more" @click="moreData">
                更多
            </section>
        </section>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .title-date {
        height: 32px;
        > h2 {
            display: inline-block;
            height: 18px;
            line-height: 18px;
            margin-top: 7px;
            color: #152c3c;
            font-size: 16px;
            border-left: 4px solid #2ca4f7;
            padding-left: 10px;
        }
        > .date {
            float: right;
            height: 100%;
            > .date-radio {
                border: 1px solid #c6cacf;
                height: 100%;
                width: 270px;
                display: inline-flex;
                > span {
                    width: 90px;
                    height: 100%;
                    line-height: 32px;
                    text-align: center;
                    cursor: pointer;
                    &:nth-of-type(n+2) {
                        border-left: 1px solid #c6cacf;
                    }
                    &.active {
                        color: #FFF;
                        background-color: #2ca4f7;
                    }
                }
            }
            > .compare-box {
                height: 100%;
                display: inline-block;
                line-height: 32px;
                margin-right: 50px;
                > .flatpickr-input {
                    display: inline-block;
                    width: 140px;
                    height: 100%;
                    vertical-align: top;
                    text-align: center;
                }
                > span {
                    display: inline-block;
                    width: 140px;
                    height: 100%;
                    vertical-align: top;
                    border: 1px solid #CCC;
                    background-color: #f9f9f9;
                    cursor: not-allowed;
                    text-align: center;
                }
                > input[type="button"] {
                    width: 90px;
                    display: inline-block;
                    height: 100%;
                    background-color: #2ca4f7;
                    color: #FFF;
                    border: 0;
                }
            }
            > .flatpickr-input {
                width: 185px;
                height: 100%;
                display: inline-block;
                vertical-align: top;
            }
            > .download {
                border: 1px solid #c6cacf;
                height: 100%;
                width: 90px;
                display: inline-block;
                vertical-align: top;
                line-height: 32px;
                text-indent: 25px;
                background: url(~static/img/xiazai-gray.png) no-repeat 80% center;
                background-size: 11px;
                color: #4C4E50;
                cursor: pointer;
            }
            > .more {
                display: inline-block;
                vertical-align: top;
                line-height: 32px;
                color: #4C4E50;
                cursor: pointer;
            }
        }
    }
</style>

<script>
    import Moment from 'moment'
    import MomentFormat from '../../filters/moment-format'
    import DataPlatform from 'api/dataPlatform'

    export default {
        data () {
            return {
            	dateRadio: 0,  // 昨天、7天、30天
	            dateInputOption: { // 选择日期配置
		            'mode': 'range',
		            'maxDate': MomentFormat.getYestoday(),
		            'minDate': '',
		            'onClose': function (value) {
			            // 清空对比日期
			            this.dateCompareRange.startDate = '';
			            this.dateCompareRange.endDate = '';
			            this.$emit('changeCompareDate', { dateRange: this.dateCompareRange });
		            	if (value.length !== 2) {
		            		return;
                        }
                        if (!this.titleOption.dateMaxRangeLength) {
                            // 最长限制30天周期
                            if (Moment(value[1]).diff(Moment(value[0]), 'days') > 30) {
                                this.$notify.error({
                                    title: '错误',
                                    message: '最长可选30天周期'
                                })
                                return;
                            }
                        } else {
                            if (Moment(value[1]).diff(Moment(value[0]), 'days') > parseInt(this.titleOption.dateMaxRangeLength)) {
                                this.$notify.error({
                                    title: '错误',
                                    message: '最长可选' + this.titleOption.dateMaxRangeLength + '天周期'
                                })
                                return;
                            }
                        }
			            this.differenceDays = Moment(value[1]).diff(Moment(value[0]), 'days');
		            	this.dateRange.startDate = Moment(value[0]).format('YYYY-MM-DD');
			            this.dateRange.endDate = Moment(value[1]).format('YYYY-MM-DD');
			            this.getData();
		            }.bind(this)
	            },
                dateRange: {
            		startDate: this.titleOption.showDate ? this.titleOption.showDate.startDate : MomentFormat.getYestoday(),
                    endDate: this.titleOption.showDate ? this.titleOption.showDate.endDate : MomentFormat.getYestoday()
                },
                differenceDays: 6,  // 相差天数
	            dateCompareRange: {
		            startDate: '',
		            endDate: ''
	            }
            }
        },
        computed: {
	        dateCompareInputOption () {
	        	return {
			        'mode': 'single',
			        'maxDate': Moment().subtract(Moment.duration(this.differenceDays + 1, 'd')).format('YYYY-MM-DD'),
			        'minDate': '',
			        'onClose': function (value) {
				        this.dateCompareRange.startDate = Moment(value[0]).format('YYYY-MM-DD');
				        this.dateCompareRange.endDate = Moment(value[0]).add(Moment.duration(this.differenceDays, 'd')).format('YYYY-MM-DD');
			        }.bind(this)
		        }
	        }
        },
        props: ["titleOption", "initDateRange"],
        methods: {
        	// 切换昨天、7天、30天
	        changeDateRadio (e) {
		        const ev = e.target;
		        if (ev.tagName === 'SPAN') {
			        const type = parseInt(ev.dataset.type);
			        if (this.dateRadio === type) {
			        	return;
                    }
			        this.dateRadio = type;
			        switch (this.dateRadio) {
                        case 0:
                        	this.dateRange.startDate = MomentFormat.getYestoday();
	                        this.dateRange.endDate = MomentFormat.getYestoday();
	                        break;
				        case 1:
				        	this.dateRange.startDate = MomentFormat.getSevenDate();
					        this.dateRange.endDate = MomentFormat.getYestoday();
					        break;
				        case 2:
				        	this.dateRange.startDate = MomentFormat.getThirtyDate();
					        this.dateRange.endDate = MomentFormat.getYestoday();
					        break;
                    }
			        this.getData();
		        } else {
			        return;
		        }
            },

            // 获取数据
            getData () {
	            this.$emit('changeDate', { dateRange: this.dateRange });
            },

            // 下载
	        downloadData () {
	            if (this.titleOption.moduleId) {
                    if (this.titleOption.moduleId === 1 || this.titleOption.moduleId === 2 ||
                        this.titleOption.moduleId === 3 || this.titleOption.moduleId === 4) {
                        DataPlatform.downloadData(this.titleOption.bizCode, this.dateRange.startDate,
                            this.dateRange.endDate, this.titleOption.moduleId);
                    } else {
                        DataPlatform.downloadProductData(this.titleOption.bizCode, this.dateRange.startDate,
                            this.dateRange.endDate, this.titleOption.moduleId,
                            this.titleOption.productId ? this.titleOption.productId.toString() : '');
                    }
                } else {
	                // 门票数据平台相关下载
                    this.$emit('downloadMenpiaoData');
                }
            },

            // 更多
            moreData () {
                router.push({name: this.titleOption.moreUrl});
            },

            // 对比数据
	        compareData () {
	        	if (this.dateCompareRange.startDate === '' || this.dateCompareRange.endDate === '') {
			        this.$notify.error({
				        title: '错误',
				        message: '请先选择对比日期'
			        })
			        return;
                }
		        this.$emit('changeCompareDate', { dateRange: this.dateCompareRange });
            }
        }
    }
</script>






// WEBPACK FOOTER //
// TitleDate.vue?7bfa3f12